import { createContext, memo, ReactNode } from "react";

export interface NavigationVersionContextValue {
  newNavigationEnabled: boolean;
}

export const NavigationVersionContext =
  createContext<NavigationVersionContextValue>({ newNavigationEnabled: false });
NavigationVersionContext.displayName = "NavigationVersionContext";

export const NavigationVersionProvider = memo(
  function NavigationVersionProvider({ children }: { children: ReactNode }) {
    return (
      <NavigationVersionContext.Provider value={{ newNavigationEnabled: true }}>
        {children}
      </NavigationVersionContext.Provider>
    );
  },
);
